//
// RenderingType.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var RenderingType = {
    SINGLE:0,
    STACKED_ARCGIS_WEBMAP:1
};
export default RenderingType;
